
//-----------------------------------------------------
// Countdown Timer
//-----------------------------------------------------

const CountdownTimer = function () {
  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.ml-hh-countdown-timer');
    if (!sections) return;
    sections.forEach(section => { 
      var countdownEndDate = new Date(section.dataset.endDate ).getTime();

      const daysEl = section.querySelector('.days');
      const hoursEl = section.querySelector('.hours');
      const minutesEl = section.querySelector('.minutes');
      const secondsEl = section.querySelector('.seconds');

      var countdownInterval = setInterval(function () {
        var now = new Date().getTime();
        var timeRemaining = countdownEndDate - now;
  
        if (timeRemaining > 0) {
          var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
          var hours = Math.floor(
            (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          var minutes = Math.floor(
            (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
          );
          var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
          daysEl.innerText = days ;
          hoursEl.innerText = hours ;
          minutesEl.innerText = minutes ;
          secondsEl.innerText = seconds ;

        } else {
          clearInterval(countdownInterval);
          document.getElementById('countdown').innerHTML = "{{ section.settings.expired_text }}";
        }
      }, 1000);
    });
  });
}


export default CountdownTimer
